import React from 'react';
import InputMask from 'react-input-mask';
import styled from 'styled-components';

const StyledInputMask = styled(InputMask)`
    // Gets rid of the Internet Explorer default "X" on input fields
    &::-ms-clear {
      height: 0;
      width: 0;
      display: none;
    }
    font-family: ${props => props.theme.fontFamily};
    color: ${props => {
      return props.valid === false
        ? props.theme.colors.red
        : props.theme.colors.black;
    }};
    border: 0.0625em solid
      ${props => {
        return props.valid === false
          ? props.theme.colors.red
          : props.theme.colors.black;
      }};
    height: 2em;
    width: ${props => props.theme.fullWidth};
    padding: 0 0.3em;
    border-radius: 0;

    &.is-valid:focus {
      border-color: ${props => props.theme.colors.black};
    }

    &:focus {
      box-shadow: ${props => props.theme.forms.input.focusOutline};
      outline: none;
    }
    
    &:disabled {
      background: ${props => props.theme.colors.disabledInput};
    }
  }
`;

export function RenderedInputMask({ input, id, placeholder, meta, disabled }) {
  const { touched, error, warning } = meta;

  // Test for AMEX
  const mask = /^3[47]/.test(input.value)
    ? '9999 999999 99999'
    : '9999 9999 9999 9999';

  return (
    <React.Fragment>
      <StyledInputMask
        {...input}
        placeholder={placeholder}
        maskChar={null}
        id={id}
        mask={mask}
        disabled={disabled}
      />
      {touched &&
        ((error && <span className="text-danger">{error}</span>) ||
          (warning && <span className="text-warning">{warning}</span>))}
    </React.Fragment>
  );
}

export default RenderedInputMask;
